exports.validateStatisticsData = ({ validation }) => {
    if (validation.data && validation.key) {
        return validation.data[validation.key] > 0 ? true : 'NO_CHART_DATA';
    }
    return false;
};

exports.validatePercentagesData = ({ validation }) => {
    if (validation.data && validation.key) {
        if (Array.isArray(validation.data[validation.key])) {
            return validation.data[validation.key].length > 0 ? true : 'NO_CHART_DATA';
        }
    }
    return false;
};


/**
 * Simple verification that value passes a threshold
 *
 * @param {object} params
 * @param {string} params.key       Key test test in `data` object
 * @param {object} params.data      Object with data to validate
 * @param {number} params.threshold Numerical value to test against. Non-inclusive.
 * @returns {boolean}
 */
exports.validateCalloutData = ({ key, data, threshold = 0 }) => {
    if (key in data) {
        return data[key] > threshold;
    }
    return false;
};

/**
 * Validation to determine if a valid alias is selected based on the selected brand
 *
 * @param {object} action   Object containing information about the submitted form
 * @returns {boolean}
 */
exports.aliasIsValid = (action) => {
    const payload = action.payload;
    const brands = action.getState().brands;
    if (brands) {
        const selectedBrand = brands.list.find(brand => brand.id === Number(payload.brandId));
        if (selectedBrand) {
            const brandAliases = selectedBrand.BrandAliases;
            if (brandAliases && brandAliases.length > 0) {
                // If selectedBrand has BrandAliases, the selected brandAlias should be in that list
                // Note: Joi validation handles case where brand is not selected, but a brandAlias gets passed
                const brandAlias = brandAliases.find(alias => alias.id === Number(payload.brandAliasId));
                return brandAlias instanceof Object;
            }
        }
    }
    return true;
};



// WEBPACK FOOTER //
// ./src/helpers/validate.js